// extracted by mini-css-extract-plugin
export default {"parallax":"InfiniteHorizontalScroll_parallax__mtMTZ","scroller":"InfiniteHorizontalScroll_scroller__RVEqI"};